import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetAC_FindOutAwardById = createAsyncThunk(
  "findOutAward/GetAC_FindOutAwardById",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/findOutAward/GetAC_FindOutAwardById",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAC_findOutAward = createAsyncThunk(
  "findOutAward/UpdateAC_findOutAward",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/findOutAward/UpdateAC_findOutAward",
        {
          sU_NT_APP_findOutAwardId: model.sU_NT_APP_findOutAwardId,
          sU_NT_APP_findOutAwardNamesId: model.sU_NT_APP_findOutAwardNamesId,
          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAC_findOutAwardNames = createAsyncThunk(
  "DropDowns/GetAC_findOutAwardNames",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAC_findOutAwardNames");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const FindOutAward = createSlice({
  name: "FindOutAward",
  initialState: {
    FindOutAward: {},
    loadingFindOutAward: false,
    errorFindOutAward: null,
    //------------------update----------------------
    FindOutAwardUpdate: [],
    loadingFindOutAwardUpdate: false,
    errorFindOutAwardUpdate: null,

    //------------------GetAC_findOutAwardNames----------------------
    FindOutAwardNamesList: [],
    loadingFindOutAwardNamesList: false,
    errorFindOutAwardNamesList: null,
  },
  reducers: {
    SetFindOutAward: (state, action) => {
      state.FindOutAward = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAC_FindOutAwardById.pending, (state, action) => {
        state.loadingFindOutAward = true;
        state.FindOutAward = action.payload;
        state.errorFindOutAward = null;
      })
      .addCase(GetAC_FindOutAwardById.fulfilled, (state, action) => {
        state.loadingFindOutAward = false;
        state.FindOutAward = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAC_FindOutAwardById.rejected, (state, action) => {
        state.loadingFindOutAward = false;
        state.errorFindOutAward = action.payload;
      })
      //------------------------update------------------------------------

      .addCase(UpdateAC_findOutAward.pending, (state, action) => {
        state.loadingFindOutAwardUpdate = true;
        state.FindOutAwardUpdate = action.payload;
        state.errorFindOutAwardUpdate = null;
      })
      .addCase(UpdateAC_findOutAward.fulfilled, (state, action) => {
        state.loadingFindOutAwardUpdate = false;
        state.FindOutAwardUpdate = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAC_findOutAward.rejected, (state, action) => {
        state.loadingFindOutAwardUpdate = false;
        state.errorFindOutAwardUpdate = action.payload;
      })
      
      
        //------------------------FindOutAwardNamesList------------------------------------

        .addCase(GetAC_findOutAwardNames.pending, (state, action) => {
          state.loadingFindOutAwardNamesList = true;
          state.FindOutAwardNamesList = action.payload;
          state.errorFindOutAwardNamesList = null;
        })
        .addCase(GetAC_findOutAwardNames.fulfilled, (state, action) => {
          state.loadingFindOutAwardNamesList = false;
          state.FindOutAwardNamesList = action.payload; // Assuming payload has the desired data
        })
        .addCase(GetAC_findOutAwardNames.rejected, (state, action) => {
          state.loadingFindOutAwardNamesList = false;
          state.errorFindOutAwardNamesList = action.payload;
        });
  },
});
export const { SetFindOutAward } = FindOutAward.actions;

export default FindOutAward.reducer;
